import React, { FC, useCallback, useEffect, useState } from 'react'
import { Button, Modal, Tab, Tabs } from 'react-bootstrap'
import UploadCsvProduct from './UploadCsvProduct'
import UploadCsvInventory from './UploadCsvInventory'

type UploadCsvTab = 'product' | 'inventory'

type Props = {
    show: boolean
    handleClose: () => void
    platformId: string | undefined
    connectedPlatformTypes?: Record<string, any> | null
}

const uploadCsvDownloadBtnHoverStyle = `
.upload-csv-download-btn:hover i {
    color: #ffffff !important;
}
`

const UploadCsvModal: FC<Props> = ({ show, handleClose, platformId, connectedPlatformTypes }) => {
    const [activeTab, setActiveTab] = useState<UploadCsvTab>('product')
    const [productBusy, setProductBusy] = useState(false)
    const [inventoryBusy, setInventoryBusy] = useState(false)

    useEffect(() => {
        if (show) {
            setActiveTab('product')
        }
    }, [show])

    const handleCloseModal = useCallback(() => {
        handleClose()
    }, [handleClose])

    const isFooterBusy = activeTab === 'product' ? productBusy : inventoryBusy

    return (
        <>
            <style>{uploadCsvDownloadBtnHoverStyle}</style>
            <Modal show={show} onHide={handleCloseModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Bulk Upload</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ paddingBottom: 0 }}>
                    <Tabs
                        activeKey={activeTab}
                        className="mb-3"
                        transition={false}
                        onSelect={(key) => {
                            if (key === 'product' || key === 'inventory') {
                                setActiveTab(key)
                            }
                        }}
                    >
                        <Tab eventKey="product" title="Upload Product">
                            <UploadCsvProduct
                                show={show}
                                isActive={show && activeTab === 'product'}
                                handleClose={handleCloseModal}
                                platformId={platformId}
                                connectedPlatformTypes={connectedPlatformTypes}
                                onBusyChange={setProductBusy}
                            />
                        </Tab>
                        <Tab eventKey="inventory" title="Upload Inventory">
                            <UploadCsvInventory
                                show={show}
                                isActive={show && activeTab === 'inventory'}
                                handleClose={handleCloseModal}
                                platformId={platformId}
                                connectedPlatformTypes={connectedPlatformTypes}
                                onBusyChange={setInventoryBusy}
                            />
                        </Tab>
                    </Tabs>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={isFooterBusy}
                        onClick={handleCloseModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UploadCsvModal
